export const GuruCtaKind = {
  DRAFT_RENEWAL_TASKS:         'draft_renewal_tasks',
  REVIEW_ACTIONS:              'review_actions',
  LOG_INCIDENT:                'log_incident',
  OPEN_CHECKLIST:              'open_checklist',
  OPEN_CHAT_WITH_QUESTION:     'open_chat_with_question',
  VIEW_FILES:                  'view_files',
  SUMMARISE_RECENT_ACTIVITY:   'summarise_recent_activity',
  SUMMARISE_DOCUMENT:          'summarise_document',
  FIND_RELATED_CERTIFICATES:   'find_related_certificates',
  CONVERT_ACTION_TO_TASK:      'convert_action_to_task',
  SUGGEST_ASSIGNEE:            'suggest_assignee',
  DISMISS_ACTION_WITH_REASON:  'dismiss_action_with_reason',
  RESCHEDULE_TASK:             'reschedule_task',
  SUMMARISE_TASK_DEPENDENCIES: 'summarise_task_dependencies',
  SUGGEST_INCIDENT_FOLLOWUPS:  'suggest_incident_followups',
  DRAFT_INCIDENT_EMAIL:        'draft_incident_email',
  COMPLIANCE_SNAPSHOT:         'compliance_snapshot',
  WHAT_NEEDS_ATTENTION:        'what_needs_attention',
  UNIT_OCCUPANTS:              'unit_occupants',
  ENTITY_RECENT_ACTIVITY:      'entity_recent_activity',
  MEMBER_OPEN_TASKS:           'member_open_tasks',
  REVIEW_MY_TASKS:             'review_my_tasks',
  VIEW_UPCOMING_EXPIRIES:      'view_upcoming_expiries',
}
